<style lang="scss" scoped>
.smdtooltip {
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 8px;
  left: 5px;
  text-transform: none;

  &.active {
    z-index: 99;
  }

  svg {
    fill: $c-dark-grey;
  }

  .content {
    position: absolute;
    text-align: center;
    width: 300px;
    padding: 20px;
    font-size: 14px;
    background-color: white;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    transition: all 0.5s ease;
    color: $c-dark-gray;

    &.left {
      top: 15px;
      left: 15px;

      &.ttfade-enter-active,
      &.ttfade-leave-active {
        transform: translate(0, 0);
        opacity: 1;
      }

      &.ttfade-enter-from,
      &.ttfade-leave-to {
        transform: translateX(20px);
        opacity: 0;
      }
    }
    &.right {
      top: 15px;
      right: 15px;

      &.ttfade-enter-active,
      &.ttfade-leave-active {
        transform: translate(0, 0);
        opacity: 1;
      }

      &.ttfade-enter-from,
      &.ttfade-leave-to {
        transform: translateX(-20px);
        opacity: 0;
      }
    }

    &.center {
      left: 50%;
      transform: translateX(-50%);
      top: 15px;

      &.ttfade-enter-active,
      &.ttfade-leave-active {
        top: 15px;
        opacity: 1;
      }

      &.ttfade-enter-from,
      &.ttfade-leave-to {
        top: 35px;
        opacity: 0;
      }
    }
  }

  &.small {
    .content {
      width: auto;
      padding: 5px;
    }
  }
}
</style>

<template>
  <div class="smdtooltip" :class="{ active, text, small }" @mouseenter="onActivate" @mouseleave="onDeactivate">
    <Icon class="icon" :path="mdiInformationOutline" :width="25" :height="25" v-if="!text && !blank" />
    <span v-if="text && !blank">{{ text }}</span>

    <transition name="ttfade">
      <div class="content" v-if="active" :class="position">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import { mdiInformationOutline } from '@mdi/js';

export default defineComponent({
  props: {
    text: { type: String },
    small: { type: Boolean, default: false },
    blank: { type: Boolean, default: false },
    position: { type: String as PropType<'left' | 'right' | 'center'>, default: 'left' },
  },
  setup() {
    const active = ref(false);

    const onActivate = () => {
      active.value = true;
    };

    const onDeactivate = () => {
      active.value = false;
    };
    return {
      active,
      onActivate,
      onDeactivate,
      mdiInformationOutline,
    };
  },
});
</script>
